export default __webpack_public_path__ + "static/media/pantry2-before2-1024w.d5da57e0.png";